import moment from "moment";
const UnknownValue = "*";

export function valueOrUnknown(value) {
  if (value === UnknownValue) {
    return "Unknown";
  }
  return value;
}

export function birthDateRangeCheck(val) {
  return val?.birthDate
    ? moment(val?.birthDate).format("LL")
    : `${moment(val?.birthDateRangeStart).format("LL")} - ${moment(val?.birthDateRangeEnd).format("LL")}`;
}

export function displayName(first, middle, last, suffix) {
  const firstDisplay = valueOrUnknown(first);
  const middleDisplay = valueOrUnknown(middle);
  const lastDisplay = valueOrUnknown(last);
  if (firstDisplay === "Unknown" && middleDisplay === "Unknown" && lastDisplay === "Unknown") {
    return "Unknown";
  }
  // Keep any name field with a value, separated by strings
  return [firstDisplay, middleDisplay, lastDisplay, suffix].filter(Boolean).join(" ");
}

export function displayAddress(street1 = "", street2 = "", city = "", state = "", zip5 = "", zip4 = "", country = "") {
  const zip = [zip5, zip4].filter(Boolean).join("-");

  const addressParts = [
    (street1 ?? "") + " " + (street2 ?? ""),
    city ?? "",
    state ? (state ?? "") + " " + (zip ?? "") : country ?? "",
  ];

  return (
    addressParts
      // Remove any leading/trailing whitespace
      .map((part) => part.trim())
      // Remove any fields that are empty
      .filter(Boolean)
      // Combine them with commas & spaces
      .join(", ")
  );
}

export function displayDateMMDDYYYY(date) {
  if (date === UnknownValue) {
    return "Unknown";
  } else if (!date) {
    return "";
  }
  const momentDate = moment(date);
  if (!momentDate.isValid()) {
    return "Invalid date: " + date;
  }
  return momentDate.format("MM/DD/yyyy");
}
